<template>
  <transition name="expand-fade" @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
    <div class="rf-transition">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'RfExpandFade',
  methods: {
    enter (el) {
      // Set max height of transition wrapper to total height (including margins)
      // of its first child (which will be the content we're transitioning)
      el.style.maxHeight = this._getMaxHeight(el.children[0]) + 'px'
    },
    afterEnter (el) {
      el.style.maxHeight = 'none'
    },
    beforeLeave (el) {
      el.style.maxHeight = this._getMaxHeight(el.children[0]) + 'px'
    },
    _getMaxHeight (el) {
      var marginTop = this._getUnitlessValue(window.getComputedStyle(el).marginTop)
      var marginBottom = this._getUnitlessValue(window.getComputedStyle(el).marginBottom)
      return el.offsetHeight + marginTop + marginBottom
    },
    _getUnitlessValue (unitString) {
      return parseFloat(unitString.replace(/[^-\d.]/g, ''))
    }
  }
}
</script>



// WEBPACK FOOTER //
// RfExpandFade.vue?4cb2f6fc